import Vue from "vue";


const success = (context, response) => {
  context.fetch_events();
  toastr.success(response.data.msg);
  context.loading = false;
};

const failed = (context, response) => {
  toastr.error(response.data.msg);
  context.loading = false;
};

export default (context, event) => Vue.$http.post('/replay-events', { id: event.id }).then((response) => {
  if (response && response.status === 200) {
    success(context, response);
  }
}).catch((error) => {
  if (error.response) {
    failed(context, error.response);
  }
});



// WEBPACK FOOTER //
// ./src/app/services/account/replayPayment.js